import React, { useEffect, useContext, useState } from "react";
import { LoginContext } from "./Login";
import Menu from "./Menu";
import { getCookie } from "../global/Global";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTags,
  faUserXmark,
  faMars,
  faVenus,
} from "@fortawesome/free-solid-svg-icons";
import DefaultAvatar_150 from "../default-avatar_150.png";
import "./Blocks.css";

const Blocks = () => {
  const { user, reloadUserInfo } = useContext(LoginContext);
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    if (!user) return;

    document.title = `${__("Blocks")} - Talkvio`;
  }, [user]);

  // Fetch blocked users data when user.blockusers changes
  useEffect(() => {
    const fetchBlockedUsers = async () => {
      if (!user?.blockusers) {
        setBlockedUsers([]);
        return;
      }

      const userIds = user.blockusers
        .split(",")
        .map((id) => parseInt(id.trim()))
        .filter((id) => id > 0);

      if (userIds.length === 0) {
        setBlockedUsers([]);
        return;
      }

      logT("blocks", "fetching blocked users", userIds);

      setLoadingUsers(true);
      try {
        const token = getCookie("token");
        const data = await window.TALKVIOAPI("users", {
          userid: user.userid,
          token,
          userids: userIds,
          limit: userIds.length,
        });

        if (data.users) {
          setBlockedUsers(data.users);
        }
      } catch (error) {
        console.error("Failed to fetch blocked users:", error);
      } finally {
        setLoadingUsers(false);
      }
    };

    fetchBlockedUsers();
  }, [user?.blockusers, user?.userid]);

  if (!user) {
    return;
  }

  return (
    <div className="blocksPage typicalBlock">
      <div className="blockedTags">
        <div className="title">
          <FontAwesomeIcon icon={faTags} />
          &nbsp; {__("Blocked tags")}
        </div>
        {user.blocktags ? (
          <ul className="taglist">
            {user.blocktags.split(",").map((blockedTag, index) => (
              <li className="tag" key={index}>
                <Menu
                  items={[
                    {
                      name: __("Unblock"),
                      click: async (close) => {
                        await window.TALKVIOAPI("blockTag", {
                          userid: user.userid,
                          token: getCookie("token"),
                          tag: blockedTag,
                        });
                        close();
                      },
                    },
                  ]}
                >
                  #{blockedTag}
                </Menu>
              </li>
            ))}
          </ul>
        ) : (
          <p>{__("No blocked tags")}</p>
        )}
      </div>

      <div className="blockedUsers">
        <div className="title">
          <FontAwesomeIcon icon={faUserXmark} />
          &nbsp; {__("Blocked users")}
        </div>
        {loadingUsers ? (
          <p>{__("Loading...")}</p>
        ) : blockedUsers.length > 0 ? (
          <ul className="userlist">
            {blockedUsers.map((blockedUser) => (
              <li className="user" key={blockedUser.userid}>
                <Menu
                  items={[
                    {
                      name: __("Unblock"),
                      click: async (close) => {
                        const data = await window.TALKVIOAPI("blockUser", {
                          userid: user.userid,
                          token: getCookie("token"),
                          targetuserid: blockedUser.userid,
                        });
                        if (data.success) {
                          reloadUserInfo();
                        }
                        window.displayError(data);
                        close();
                      },
                    },
                  ]}
                >
                  <div className="user-info">
                    <div className="avatar">
                      <img
                        src={
                          blockedUser.avatarrevision > 0
                            ? `https://talkvio.com/customavatars/avatar${blockedUser.userid}_${blockedUser.avatarrevision}.gif`
                            : DefaultAvatar_150
                        }
                        alt={"Avatar for " + blockedUser.username}
                      />
                    </div>
                    <div className="username">
                      {blockedUser.username}
                      {blockedUser.gender && blockedUser.gender !== "none" ? (
                        <sup className="gender">
                          {blockedUser.gender == "male" ? (
                            <FontAwesomeIcon className="male" icon={faMars} />
                          ) : null}
                          {blockedUser.gender == "female" ? (
                            <FontAwesomeIcon
                              className="female"
                              icon={faVenus}
                            />
                          ) : null}
                        </sup>
                      ) : null}
                    </div>
                  </div>
                </Menu>
              </li>
            ))}
          </ul>
        ) : (
          <p>{__("No blocked users")}</p>
        )}
      </div>
    </div>
  );
};

export default Blocks;
